import { render, staticRenderFns } from "./LinkedInstitutionsStep.vue?vue&type=template&id=6c04a5c7&scoped=true&"
import script from "./LinkedInstitutionsStep.vue?vue&type=script&lang=js&"
export * from "./LinkedInstitutionsStep.vue?vue&type=script&lang=js&"
import style0 from "./LinkedInstitutionsStep.vue?vue&type=style&index=0&id=6c04a5c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c04a5c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c04a5c7')) {
      api.createRecord('6c04a5c7', component.options)
    } else {
      api.reload('6c04a5c7', component.options)
    }
    module.hot.accept("./LinkedInstitutionsStep.vue?vue&type=template&id=6c04a5c7&scoped=true&", function () {
      api.rerender('6c04a5c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/portal-cebas/credentialing/steps/LinkedInstitutionsStep.vue"
export default component.exports